/** Shop decor in the shop sheet (hud.tsx ShopSheet): the Decorate switch and the panel shown while decorating. */
import type { JSX } from 'preact';
import { t } from '../i18n/index.js';
import type { ShopHud } from './bridge.js';
import { Button } from './components.js';
import { Check } from './icons.js';

type Decorate = NonNullable<ShopHud['decorate']>;

export function DecorateButton({ d }: { d: Decorate }): JSX.Element {
  return (
    <Button variant="secondary" size="sm" onClick={d.onToggle} testId="shop-decorate">
      {t('shop.decorate')}
    </Button>
  );
}

/** While decorating the upgrade list steps aside: glowing spots in the shop do the work. */
export function DecoratePanel({ d }: { d: Decorate }): JSX.Element {
  return (
    <div class="shop-sheet decorating" data-testid="shop-sheet">
      <div class="sheet-head">
        <div>
          <h2>{t('shop.decorate')}</h2>
          <small>{t('shop.decorateHint')}</small>
        </div>
        <Button variant="teal" size="sm" onClick={d.onToggle} testId="shop-decorate-done">
          <Check size={18} /> {t('shop.decorateDone')}
        </Button>
      </div>
      <Button variant="ghost" size="sm" onClick={d.onStore} testId="shop-decor-store">
        {t('shop.getDecor')}
      </Button>
    </div>
  );
}
